/**
 * @module store/marathons/mutations
 *
 * @version 1.0.2
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {

  /**
   * Mutation: Успешная загрзка страницы со стартами
   *
   * @since Version 1.0.2
   */
  [types.GET_CHALLENGES_ASYNC.SUCCESS](state, { data, total }) {
    state.challenges = data;
    state.total = total;
    state.isLoading = false;
  },
};
/* eslint-enable no-param-reassign */
